<template>
  <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
    <g fill="#FFF" fill-rule="nonzero">
      <path
        d="M.845.845A.75.75 0 011.82.772l.084.073L13.18 12.12a.75.75 0 01-.976 1.133l-.084-.073L.845 1.905a.75.75 0 010-1.06z"
      />
      <path
        d="M12.095.845a.75.75 0 011.133.976l-.073.084L1.88 13.18a.75.75 0 01-1.133-.976l.073-.084L12.095.845z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconClose',
};
</script>

<style></style>
